import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedCompanyStudyNextActionApiService } from './company-study-next-action-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyStudyNextActionApiService extends GeneratedCompanyStudyNextActionApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
